import { render, staticRenderFns } from "./QuestionBtns.vue?vue&type=template&id=cb8c7a64&"
import script from "./QuestionBtns.vue?vue&type=script&lang=js&"
export * from "./QuestionBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports